<template>
  <div class="page_enterpriseLibrary">
    <div class="topOperation">
      <div class="top-left">
        <ShowNavHead />
        <div class="screenInputs">
          <div class="screenInput">
            <div class="flname">企业全称:</div>
            <el-input v-model="listQuery.strEntName" size="small" clearable @keyup.enter.native="searchHandle"></el-input>
          </div>
          <div class="screenInput">
            <div class="flname">地址:</div>
            <el-input v-model="listQuery.StrEntAdd" size="small" clearable @keyup.enter.native="searchHandle"></el-input>
          </div>
          <div class="screenInput cp">
            <el-tooltip class="scr_icon" effect="dark" content="高级检索项" placement="top-start">
              <i class="i_txt" @click="dropDownScreen">{{showDropScreen==1 ? '收起':'更多'}}<i class="el-icon-caret-bottom"></i></i>
            </el-tooltip>
          </div>
        </div>
      </div>
      <div class="top-right">
        <el-button v-if="showDropScreen==-1" type="success" size="small" @click="searchHandle" style="margin-right:24px">搜索</el-button>
      </div>
    </div>
    <!-- 筛选下拉框 -->
    <div class="r_dropDownScreen" v-show="showDropScreen==1">
      <div class="pro_down_box">
        <el-form :inline="true" :model="listQuery" class="re_down_form1" label-width="100px">
          <el-form-item label="业务状态:">
            <el-select v-model="listQuery.AddTelFollow" size="small" placeholder="" clearable>
              <el-option label="公海" value="公海"></el-option>
              <el-option label="跟进中" value="跟进中"></el-option>
              <el-option label="合作中" value="合作中"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="联系人:">
            <el-select v-model="listQuery.StrEnttel" size="small" placeholder="" clearable>
              <el-option label="有" value="1"></el-option>
              <el-option label="无" value="0"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="企业规模:">
            <el-select
              v-model="listQuery.StrEntScale" size="small" placeholder="" clearable
            >
              <el-option
                v-for="(item, index) in scaleList"
                :key="index + 'b'"
                :label="item"
                :value="item"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="行业:">
            <el-input v-model="listQuery.StrEntIndustry" size="small" clearable></el-input>
          </el-form-item>
          <el-form-item label="数据来源:">
            <el-select v-model="listQuery.strDataSource" size="small" placeholder="" clearable>
              <el-option label="导入" value="导入"></el-option>
              <el-option label="CRM同步" value="CRM同步"></el-option>
              <el-option label="采集" value="采集"></el-option>
              <!-- <el-option label="数字化系统" value="数字化系统"></el-option> -->
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <div class="drop-footer">
        <el-button size="small" plain @click="clear()">清空</el-button>
        <el-button size="small" type="info" plain @click="showDropScreen=-1">关闭</el-button>
        <el-button size="small" type="success" @click="searchHandle()">搜索</el-button>
      </div>
    </div>
    <div class="main-con">
      <div class="crumbs flex sb">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>产品</el-breadcrumb-item>
          <el-breadcrumb-item>营销雷达</el-breadcrumb-item>
          <el-breadcrumb-item>管理</el-breadcrumb-item>
          <el-breadcrumb-item>企业库</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div>
        <comTabs ref="child" :active="activeName"></comTabs>
        <el-table :data="tableData" style="width: 100%" v-loading="tableLoading" border :highlight-current-row="true">
          <el-table-column align="center" label="序号" fixed="left" width="60px" fit :show-overflow-tooltip="true">
            <template slot-scope="{$index}">
              <span>{{(Number(listQuery.currpage) - 1) * Number(listQuery.perpage) + Number($index) + 1}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="StrEntNice" label="企业全称" fixed="left" :show-overflow-tooltip="true" min-width="230px" align="center">
          </el-table-column>
          <el-table-column prop="StrProvince" label="地区/省" :show-overflow-tooltip="true" min-width="100px" align="center">
          </el-table-column>
          <el-table-column prop="StrCity" label="地区/市" :show-overflow-tooltip="true" min-width="100px" align="center">
          </el-table-column>
          <el-table-column prop="StrEntAdd" label="详细地址" :show-overflow-tooltip="true" min-width="200px" align="center">
          </el-table-column>
          <el-table-column prop="StrEntScale" label="企业规模" :show-overflow-tooltip="true" min-width="80px" align="center">
          </el-table-column>
          <el-table-column prop="StrEntIndustry" label="行业" :show-overflow-tooltip="true" min-width="100px" align="center">
          </el-table-column>
          <!-- <el-table-column prop="EntWebsite" label="企业官网"  width="80" align="center">
            <template slot-scope="scope">
              <span title="点击可跳转详情" v-if="scope.row.EntWebsite" @click="jumpOtherNet(scope.row.EntWebsite)" class="j_url_txt">查看官网</span>
            </template>
          </el-table-column> -->
          <el-table-column prop="AddTelFollow" label="业务状态" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="StrDataSource" label="数据来源" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="StrEnttel" label="联系人" align="center">
            <template slot-scope="scope">
                <span class="contacts cp">
                  <el-popover :popper-class="(scope.row.isThirdTel == 'sure' && !isContactsByOther)?'market_popover_box':''" placement="left" :width="isContactsByOther ? 150 : 640" trigger="click" :ref="`popover-${scope.$index}`">
                    <el-table class="ent_tel_box" v-show="!isContactsByOther" :data="contactsList" v-loading="contactsLoading">
                      <el-table-column min-width="120px" property="entname"
                        label="企业全称" fit :show-overflow-tooltip="true" align="center"
                      ></el-table-column>
                      <el-table-column min-width="100px" property="ContactPerson"
                        label="联系人" fit :show-overflow-tooltip="true"
                        align="center"
                      ></el-table-column>
                      <el-table-column min-width="100px" property="ContactPsnpost"
                        label="职位" fit :show-overflow-tooltip="true"
                        align="center"
                      ></el-table-column>
                      <el-table-column min-width="110px" property="TelNum"
                        label="联系方式" fit :show-overflow-tooltip="true"
                        align="center"
                      ></el-table-column>
                      <el-table-column min-width="80px" property="Source"
                        label="来源" fit :show-overflow-tooltip="true"
                        align="center"
                      ></el-table-column>
                      <el-table-column min-width="130px" property="DtInsertDate"
                        label="操作时间" fit :show-overflow-tooltip="true"
                        align="center"
                      >
                        <template slot-scope="{ row }">
                          <span>{{
                            isNull(row.DtInsertDate)
                              ? ""
                              : row.DtInsertDate.replace("T", " ")
                          }}</span>
                        </template>
                      </el-table-column>
                    </el-table>
                    <div v-if="!isContactsByOther&&(!isNull(contactsList))">
                      <el-pagination
                        @current-change="diaCurrentChange"
                        :current-page.sync="comTelQuery.currpage"
                        :page-size="comTelQuery.perpage"
                        @size-change="diaSizeChange"
                        :page-sizes="[10, 20, 50, 100, 200]"
                        layout="total,sizes,prev,pager,next,jumper"
                        :total="comTotal"
                      ></el-pagination>
                    </div>
                    <div v-show="isContactsByOther">
                      <div class="confirmTitle">查询联系方式</div>
                      <div class="btnBox flex">
                        <div class="confirmBtn cp" @click="confirmGetentContactnumbyother(scope.$index)">确定</div>
                        <div class="cancelBtn cp" @click="cancel(scope.$index)">取消</div>
                      </div>
                    </div>
                    <img v-if="scope.row.StrEnttel == 1" src="../../assets/images/contacts.png" alt="" slot="reference" @click="getentcontactnum(scope.row)" title="查看联系人及联系方式" />
                    <img v-if="scope.row.StrEnttel == 0" src="../../assets/images/seach.png" alt="" slot="reference" @click="getentContactnumbyother(scope.row)" title="天眼查获取联系人及联系方式" />
                  </el-popover>
                </span>
              </template>
          </el-table-column>
          <!-- <el-table-column fixed="right" label="操作" width="200" align="center">
            <template slot-scope="scope">
              <el-button @click="editCollectSetSet(scope.row)" type="text" size="small">编辑</el-button>
            </template>
          </el-table-column> -->
        </el-table>
        <div class="block">
          <el-pagination @current-change="changeBPage" :current-page.sync="listQuery.currpage" :page-size="listQuery.perpage" @size-change="handleSizeChange" :page-sizes="[10, 20, 50, 100]" layout="total,sizes,prev,pager, next, jumper" :total="total"></el-pagination>
        </div>
      </div>
    </div>

    <div class="page_reportSet_dialog">
      <el-dialog :title="info ? '修改配置' : '新建配置'" :visible.sync="dialogVisibleSet" width="420px" :close-on-click-modal="false">
        <el-form :model="query" :rules="rules" ref="form" label-width="100px" class="demo-query">
          <el-form-item label="企业简称:" prop="rule">
            <el-input v-model="query.strRuleName" placeholder="请输入企业简称" style="width: 221px;" clearable></el-input>
          </el-form-item>

          <el-form-item label="企业全称:" prop="platform">
            <el-input v-model="query.strplatform" placeholder="请输入企业全称" style="width: 221px;" clearable></el-input>
          </el-form-item>

          <el-form-item label="联系人:" prop="platform">
            <el-input v-model="query.strplatform" placeholder="请输入联系人" style="width: 221px;" clearable></el-input>
          </el-form-item>

          <el-form-item label="业务状态:" prop="platform">
            <el-input v-model="query.strplatform" type="number" placeholder="请输入联系方式" style="width: 221px;" clearable></el-input>
          </el-form-item>

          <el-form-item label="业务部门:" prop="platform">
            <el-input v-model="query.strplatform" placeholder="请输入企业全称" style="width: 221px;" clearable></el-input>
          </el-form-item>

          <el-form-item label="业务员:" prop="platform">
            <el-input v-model="query.strplatform" placeholder="请输入企业全称" style="width: 221px;" clearable></el-input>
          </el-form-item>

        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisibleSet = false">取 消</el-button>
          <el-button type="primary" @click="addCollectionConfig()">确 定</el-button>
        </span>
      </el-dialog>

    </div>
  </div>
</template>

<script>
  import xz from "../../common";
  import comTabs from './components/comTab.vue'
  export default {
    components:{
      comTabs
    },
    data() {
      return {
        activeName:'企业库',
        tableHeight: 0,
        tableData: [],
        contactsData:[],//联系人列表
        contactsList:[],
        isContactsByOther: false, //是否是从其他渠道取联系方式
        contactsLoading:false,
        tableLoading: false,
        info: {},
        total: 0,
        showDropScreen: -1,
        query: {
          Collid: '', //id
          strplatform: '', //平台名称
          strRuleName: '', //规则
          strStatus: '', //状态
          struserid: Cookies.get("userid-b"), //操作人id
        },
        rules: {},
        dialogVisibleSet: false,
        listQuery: {
          currpage: 1,
          perpage: 10,
          strEntName: '', // 企业
          StrEntAdd:'',//地址
          AddTelFollow: '', // 状态
          StrEntIndustry: '', //行业
          StrEntScale: '', //规模
          StrDataSource: '', //数据来源
          StrEnttel: '' //联系人 1有
        },
        // 查询企业联系方式参数
        comTelQuery:{
          GdEntId:'',
          strEntNice:'',
          strteltype:'looktel',//跟进follow  其他查看looktel
          currpage:1,
          perpage:10
        },
        comTotal:0,
        scaleList: ["200人以上", "500人以上", "2000人以上", "5000人以上"]
      }
    },
    created() {
      this.calHeight();
      this.getTabData();
    },
    methods: {
      calHeight() {
        this.tableHeight = Number(document.body.clientHeight);
        console.log('height', this.tableHeight)
      },
      //判断是否为空(包含0)
      isNull(o) {
        return o == undefined || o == "undefined" || (o + '').indexOf("undefined") > -1 || o == null || o == '' || o == 'null' || o == [] || o == 0 || o == 'NaN';
      },
      //新增设置
      AddReportSet() {
        this.info = '';
        this.clear();
        this.dialogVisibleSet = true;
      },
      getTabData() {
        this.tableLoading = true;
        xz.getEntListsNew(this.listQuery).then(res => {
          if (res.status == 'ok') {
            this.tableData = res.msg;
            this.total = Number(res.totalcount)
          } else {
            this.tableData = [];
            this.total = 0
          }
          this.tableLoading = false
        })
      },
      //分页
      changeBPage(val) {
        this.listQuery.currpage = val;
        this.getTabData();
      },
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
        this.listQuery.currpage = 1;
        this.listQuery.perpage = val;
        this.getTabData();
      },
      clear() {
        this.listQuery = this.$options.data.call(this).listQuery
      },
      //筛选下拉
      dropDownScreen() {
        if (this.showDropScreen == -1) {
          this.showDropScreen = 1;
        } else if (this.showDropScreen == 1) {
          this.showDropScreen = -1;
        }
      },
      // 搜索
      searchHandle() {
        this.listQuery.currpage = 1;
        this.getTabData();
        this.showDropScreen = -1;
      },
      editCollectSetSet(row) {
        this.info = row;
        this.query.Collid = row.Collid;
        this.query.strplatform = row.strplatform;
        this.query.strRuleName = row.strRuleName;
        this.query.strStatus = row.strStatus;
        this.query.struserid = Cookies.get("userid-b");
        this.dialogVisibleSet = true;
      },
      //添加/编辑 采集配置
      addCollectionConfig() {
        console.log(this.query)
        xz.addCollectionConfig(this.query).then(res => {
          if (res.status == 'ok') {
            this.getTabData();
            this.$message.success('保存成功！')
          }
          this.dialogVisibleSet = false;
        })
      },
      //获取联系人和联系方式
      getentcontactnum(item){
        this.contactsLoading = true
        this.comTelQuery.GdEntId = item.GdEntId
        this.comTelQuery.strEntNice = item.StrEntNice
        this.getTelData(item.StrEntNice);
      },
      getentContactnumbyother(item) {
        this.isContactsByOther = true;
        this.info = item;
        this.comTelQuery.strEntNice = item.StrEntNice
        this.comTelQuery.GdEntId = item.GdEntId
      },
      //其他方式取联系方式
      confirmGetentContactnumbyother(index) {
        this.$set(this.tableData[index], 'StrEnttel', 1);
        this.$set(this.tableData[index], 'isThirdTel', 'sure');
        this.isContactsByOther = false;
        this.getThirdView(this.comTelQuery.strEntNice);
      },
      // 天眼查或其他三方查询联系人
      getThirdView(StrEntNice){
        let that = this
        xz.getentContactnumbyother(StrEntNice).then((res) => {
          if (res.status == "ok") {
            that.getTelData();
          } else {
            that.contactsList = [];
          }
        });
      },
      // 查询企业联系方式
      getTelData(){
        let that = this
        this.contactsLoading = true;
        // that.contactsList = [];
        xz.getEntContactlist(this.comTelQuery).then((res) => {
          if (res.status == "ok") {
            this.contactsList = res.data;
            for (let i = 0; i < res.data.length; i++) {
              let element = res.data[i];
              that.$set(element, "entname", that.comTelQuery.strEntNice);
            }
            this.comTotal = Number(res.totalcount)
          } else {
            this.contactsList = [];
            this.comTotal = 0
          }
          this.contactsLoading = false;
        });
      },
      //分页
      diaCurrentChange(val) {
        this.comTelQuery.currpage = Number(val);
        this.getTelData();
      },
      diaSizeChange(val) {
        this.comTelQuery.currpage = 1;
        this.comTelQuery.perpage = Number(val);
        this.getTelData();
      },
      cancel(index) {
        console.log(index)
        this.$refs[`popover-${index}`].doClose()
      },
      // 跳转岗位详情页
      jumpOtherNet(url) {
        window.open(url, '_blank');
      },
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .flname {
    min-width: 40px;
    width: 72px;
    padding-right: 8px;
    box-sizing: border-box;
  }

  .r_dropDownScreen {
    width: 100%;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    background-color: #fff;
  }

  .re_down_form .el-form-item {
    margin-bottom: 3px;
    margin-right: 0;
  }

  .contacts img {
    width: 24px;
    height: 24px;
  }
  .confirmTitle {
    padding: 14px 5px;
  }

  .cancelBtn {
    color: #409eff;
    margin-right: 53px;
  }

  .confirmBtn {
    color: #fff;
    background-color: #409eff;
    border-color: #409eff;
    width: 55px;
    height: 24px;
    line-height: 24px;
    text-align: center;
    border-radius: 5px;
  }

  .btnBox {
    width: 100%;
    flex-direction: row-reverse;
    align-items: center;
    font-size: 13px;
  }
  .j_url_txt {
    /* color:#67C23A; */
    text-decoration: underline;
    cursor: pointer;
  }
</style>
<style>
.el-popover.market_popover_box{
  left: calc(100% - 770px)!important;
}
.ent_tel_box.el-table .el-table__cell{
  padding: 3px 0;
}
.page_enterpriseLibrary .screenInput .el-input,
.page_enterpriseLibrary .r_dropDownScreen .el-select,
.page_enterpriseLibrary .r_dropDownScreen .el-form-item__content{
  width: 200px;
}
.page_enterpriseLibrary .r_dropDownScreen .el-form--inline .el-form-item{
  margin-bottom: 5px;
}
  .page_enterpriseLibrary .el-table .el-table__cell {
    padding: 3px 0;
  }

  .strBusiStatus .el-input {
    width: 200px !important;
  }
.page_enterpriseLibrary .screenInput{
  margin: 0 0 10px 0;
}
  .page_enterpriseLibrary .screenInput .el-select .el-input__inner {
    width: 200px;
  }
</style>